import { render, staticRenderFns } from "./resHeader.vue?vue&type=template&id=66f43bf2&scoped=true"
import script from "./resHeader.vue?vue&type=script&lang=js"
export * from "./resHeader.vue?vue&type=script&lang=js"
import style0 from "./resHeader.vue?vue&type=style&index=0&id=66f43bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f43bf2",
  null
  
)

export default component.exports